// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"1fb0e697","349":"7f7d6735","488":"61034297","551":"f856afdc","675":"dd7fdfc2","828":"5d5f06af","842":"5bea4533","950":"c7128e18"}[chunkId] + ".chunk.js";
};